import type { ReactNode } from "react";

import { LayoutContextProvider } from "@/react/components/SettingsApp/Layout/LayoutContext";

import { SettingsShellDesktop } from "./SettingsShellDesktop";

interface SettingsShellProps {
  children: ReactNode;
  shouldHideSidebarNestedNavBar?: boolean;
}

export const SettingsShell = ({
  children,
  shouldHideSidebarNestedNavBar,
}: SettingsShellProps) => (
  <LayoutContextProvider>
    <SettingsShellDesktop
      shouldHideSidebarNestedNavBar={shouldHideSidebarNestedNavBar}
    >
      {children}
    </SettingsShellDesktop>
  </LayoutContextProvider>
);
